module.exports = __webpack_public_path__ + "img/invest.d12d17dc.svg";